import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findBySelectedItem',
  standalone: true
})
export class FindBySelectedItemPipe implements PipeTransform {
  public transform<T = any>(selectedItem: string | number, options: T[], dataKey: string, group = false): T {
    if (!options || !Array.isArray(options) || !selectedItem) {
      return undefined;
    }

    if (group) {
      let _selectedItem: any;
      options.forEach((group) => {
        if (group['items'].findIndex((opt: any) => selectedItem === opt[dataKey]) !== -1) {
          _selectedItem = group['items'].find((opt: any) => selectedItem === opt[dataKey]);
        }
      });
      return _selectedItem;
    }

    return options.find((opt) => selectedItem === opt[dataKey]);
  }
}
